import React from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { Radiobuttons } from 'components';
import { getProductInfoBySlotName } from 'utils/project-definition/component';
import {
  setChimneyDiameter,
  getChimneyDiameterValue,
  getChimneyLayout,
} from 'utils/project-definition/component/chimney';

export function isOptionRequired(item) {
  return item.required || item.is_adapter;
}

export function addComponentTypePropertyRenders(
  slotName, systemDefinition, systemProducts, product,
  optionsPanel, optionsPanelLocation, resultArray,
) {
  if (optionsPanelLocation !== 'middle') {
    return;
  }

  const chimneyLayout = getChimneyLayout(slotName, systemDefinition, systemProducts);

  const kettleSlotName = 'kettle';
  const productData = getProductInfoBySlotName(kettleSlotName, systemDefinition, systemProducts);
  const productId = productData ? productData.id : null;
  const disabled = optionsPanel && optionsPanel.props ? optionsPanel.props.disabled : false;

  const changedDiameterHandler = (value, data) => {
    setChimneyDiameter(data, slotName, systemDefinition, systemProducts);
    optionsPanel.itemPropertyChangedHandler('diameter', value);
  };

  const { diameters } = productData;
  const numDiameters = diameters ? diameters.length : 0;
  const propertyElements = numDiameters > 0 ? [] : null;

  for (let i = 0; i < numDiameters; i += 1) {
    const diameter = diameters[i];
    const diameterName = diameter.diameter;
    const diameterConfigs = diameter.configurations;

    const allowDiameter = !diameterConfigs || diameterConfigs.includes(chimneyLayout);
    if (allowDiameter) {
      propertyElements.push({
        id: diameterName,
        value: diameterName,
        data: diameter,
        label: (
          <div className="align align--fluid">
            <div className="align__row">
              <div className="align__cell">
                {diameterName}
              </div>
            </div>
          </div>
        ),
      });
    }
  }

  if (propertyElements && propertyElements.length > 0) {
    resultArray.push(
      <div
        key={`section-${productId}-${slotName}-properties`}
        className={
          classnames(
            'configurator-options-panel__item',
            'config-option-item',
            'config-option-item__title-container',
          )
        }
      >
        <FormattedMessage id="configurator.productSettings.componentTypes.chimney.diameters" />
      </div>,
    );

    const selectedProperty = getChimneyDiameterValue(kettleSlotName, systemDefinition, systemProducts);

    resultArray.push(
      <div
        key={`section-${productId}-properties`}
        className={
          classnames(
            'configurator-options-panel__item',
            'config-option-item',
            'configurator-options-panel__properties-list',
          )
        }
      >
        <Radiobuttons
          disabled={disabled}
          onChange={changedDiameterHandler}
          selected={selectedProperty}
          values={propertyElements}
        />
      </div>,
    );
  }
}



// WEBPACK FOOTER //
// ./js/components/configuration/options-panel/component-options-panels/exhaust.jsx